import React, {Fragment} from 'react';
import TopNav from "../../layouts/navs/auth-toptenants";
import BanneriCard from "../../layouts/banners/tenanticard";
import BanneriCardLease from "../../layouts/banners/tenanticardlease";
import BanneriCardSetup from "../../layouts/banners/tenanticardsetup";
import BannerCredit from "../../layouts/banners/tenantcredit";
import BannerSearch from "../../layouts/banners/tenantsearch";
import BannerApply from "../../layouts/banners/tenantapply";
import BannerNoMore from "../../layouts/banners/tenantnomore";
import BannerVerify from "../../layouts/banners/tenantverify";
import BannerID from "../../layouts/banners/tenantid";
import BannerApprove from "../../layouts/banners/tenantapprove";
import BannerExpense from "../../layouts/banners/tenantexpense";
import Benefits from "./components/main/benefits";
import TenantApply from "./components/main/apply";
import TenantLease from "./components/main/lease";
import TenantLeaseText from "./components/main/leasetext";
import TenantSignup from "./components/main/signup";
import TenantSearch from "./components/main/search_";
import TenantID from "./components/main/id";
import TenantVerify from "./components/main/verify";
import TenantApprove from "./components/main/approve_";
import TenantExpense from "./components/main/expense_";
import TenantVerify2 from "../tenants/components/main/verify2";

const AboutPage = () => {
    return (
        <Fragment>
            <TopNav/>
            
            <BannerApply/>
            
            <TenantApply/>
            
            <BanneriCardSetup/>
           
            <br/><br/>
            <TenantVerify2/>

            <BannerNoMore/>
        
            <TenantLeaseText/>

            <BanneriCardLease/>
            <br/><br/>

            <TenantLease/>

            {/* <BannerCredit/>
            <br/><br/> */}

            <TenantSignup/>
            <br/><br/>
            <br/><br/>
            
            {/* <Benefits/> */}

            {/* <BanneriCard/> */}
            {/* <BannerVerify/> */}
            {/* <TenantVerify/> */}

            {/* <BannerID/> */}
            {/* <TenantID/> */}
            
            {/* <BannerSearch/> */}
            {/* <TenantSearch/> */}

            {/* <BannerID/> */}
            {/* <TenantID/> */}

            {/* <BannerApprove/>
            <TenantApprove/>

            <BannerExpense/>
            <TenantExpense/> */}
        </Fragment>
    );
};

export default AboutPage;
